export default {
  ROUTES: {
    PASSPORT: 'passport_details',
    VISA: 'visa_details',
    FINANCIAL: 'financial_details',
    ADDITIONAL: 'additional_details',
    PAYMENT: 'payment_details',
    SUCCESS: 'success',
    EXPIRED: 'expired',
    PREVIEW: 'preview',
  },
  CARDS: {
    PASSPORT: btoa('passport'),
    CONTACT_INFORMATION: btoa('contact_information'),
    TRAVEL_DETAILS: btoa('travel_details'),
    PREVIOUS_USA_VISA: btoa('previous_usa_visa'),
    PREVIOUS_OTHER_VISA: btoa('previous_other_visa'),
    TRIP_SPONSOR: btoa('trip_sponsor'),
    BANK_STATEMENT: btoa('bank_statement'),
    ITR_DETAILS: btoa('itr_details'),
    AADHAR_DETAILS: btoa('aadhar_details'),
    ADDITIONAL_DETAILS: btoa('additional_details'),
    ADDITIONAL_COMMENT: btoa('additional_comment'),
    VISA_HINT: btoa('visa_hint'),
    APPLICANT_DETAILS: btoa('applicant_details'),
  },
  get PROCESS_STEPS(): ApplicationStep[] {
    return [
      {
        title: 'Passport Details',
        sub_title: 'Verify your details to make application stronger',
        route: this.ROUTES.PASSPORT,
        next_route: this.ROUTES.VISA,
        btn: 'Save and continue',
        help_url:
          'https://drive.google.com/file/d/1eEBLQgnW-yIKUenoYX4RRMO_betzsj5s/preview',
      },
      {
        title: 'Visa Details',
        sub_title:
          'Your application looks good. Add more information to make it great.',
        route: this.ROUTES.VISA,
        previous_page: this.ROUTES.PASSPORT,
        next_route: this.ROUTES.FINANCIAL,
        btn: 'Save and continue',
        help_url:
          'https://drive.google.com/file/d/1Ehq6JFPJ1YCxmr2g9UkX0OWiLwpBFEAv/preview',
      },
      {
        title: 'Financial Details',
        sub_title:
          'Great! your application looks strong. Adding more information can make it stronger.',
        route: this.ROUTES.FINANCIAL,
        previous_page: this.ROUTES.VISA,
        next_route: this.ROUTES.ADDITIONAL,
        btn: 'Save and continue',
        help_url:
          'https://drive.google.com/file/d/1BmlyIZ4GCojIOqns60LjEjlRWHSA3Gow/preview',
      },
      {
        title: 'Additional Details',
        sub_title:
          'Great! your application looks strong. Adding more information can make it stronger.',
        route: this.ROUTES.ADDITIONAL,
        previous_page: this.ROUTES.FINANCIAL,
        next_route: this.ROUTES.PREVIEW,
        btn: 'Save and preview',
        help_url:
          'https://drive.google.com/file/d/18CMZ2Vx4_uakMuti5K_kxwIpQE0U5O1-/preview',
      },
      {
        title: 'Application Preview',
        sub_title: 'Please review your application before submitting it.',
        route: this.ROUTES.PREVIEW,
        previous_page: this.ROUTES.ADDITIONAL,
        next_route: '',
        btn: 'Submit',
        help_description:
          'Review your application carefully in Application Review Section before submitting, to ensure error free details. Please note that this action is irreversible.',
      },
    ];
  },
  SUPPORTING_DOCUMENTS:
    'Upload valid Documents (JPEG/JPG/PNG) like Marriage Certificate, Birth Certificate, Company Leave Letter, Company Appointment Letter, Company Bank Statement, Invitation Letter, Sponsor Letter, Event Ticket or Registration, Old Passport Copy, Visa in Old Passport, Single Parent Declaration for Minor, Salary Slip. You can only upload upto 10 documents.',
  RELATION_TYPES: [
    {
      value: 'Select Relation',
      label: 'Select Relation',
    },
    {
      value: 'Parent',
      label: 'Parent',
    },
    {
      value: 'Sibiling',
      label: 'Sibiling',
    },
    {
      value: 'Spouse',
      label: 'Spouse',
    },
    {
      value: 'Other',
      label: 'Other',
    },
  ],
  SELECT_BANK: 'Please select a bank',
  RELATION_PROOFS: [
    {
      value: 'select_document_type',
      label: 'Select Document Type',
      max: 0,
      verification_type: '',
      labels: [],
      required_qr: false,
    },
    {
      value: 'passport',
      label: 'Passport',
      max: 1,
      verification_type: 'manual',
      labels: ['Passport Front', 'Passport Back'],
      required_qr: false,
    },
    // {
    //   value: 'aadhar_card',
    //   label: 'Aadhar Card',
    //   max: 1,
    //   verification_type: 'document',
    //   labels: [],
    //   required_qr: false,
    // },
    // {
    //   value: 'birth_certificate',
    //   label: 'Birth Certificate',
    //   max: 1,
    //   verification_type: 'document',
    //   labels: [],
    //   required_qr: true,
    // },
    {
      value: 'marriage_certificate',
      label: 'Marriage Certificate',
      max: 3,
      verification_type: 'document',
      labels: [],
      required_qr: true,
    },
    // {
    //   value: 'itr',
    //   label: 'ITR',
    //   max: 1,
    //   verification_type: 'document',
    //   labels: [],
    //   required_qr: false,
    // },
    // {
    //   value: 'bank_statement',
    //   label: 'Bank Statement',
    //   max: 1,
    //   verification_type: 'document',
    //   labels: [],
    //   required_qr: false,
    // },

    // {
    //   value: 'spouse_passport',
    //   label: 'Spouse Passport',
    //   max: 2,
    //   verification_type: 'document',
    //   labels: ['Spouse Passport Front', 'Spouse Passport Back'],
    //   required_qr: false,
    // },
    {
      value: 'gst_certificate',
      label: 'GST Certificate',
      max: 3,
      verification_type: 'document',
      labels: [],
      required_qr: false,
    },
    // {
    //   value: 'udham_certificate',
    //   label: 'Udham Certificate',
    //   max: 1,
    //   verification_type: 'document',
    //   labels: [],
    //   required_qr: true,
    // },
  ],
  BANK_STATEMENT: {
    DOS: [
      'Submit in PDF Format. Upload the original, uncompressed files exactly as provided by your bank via email or internet banking.',
      'Provide the password for the PDF if any. It is safe to do so.',
      'Upload multiple bank statements if required.',
      'Bank statements must cover the recent 6 months period.',
      'Upload your primary bank account statement where you receive your income/salaries.',
    ],
    DONTS: [
      'Do NOT submit Excel or CSV format.',
      'Do NOT Compress the PDF file.',
      'Do NOT alter or tamper the PDF file.',
      'Do NOT use any PDF altering tool.',
      "Do NOT try to remove the password from your PDF File. Provide the password in field. It's safe.",
      'Do NOT submit documents covering less than recent 6 months.',
      'Do NOT upload credit card statements.',
      'Do NOT upload scanned bank statement.',
      'Do NOT upload current or OD account bank statements with a NEGATIVE balance.',
      "Do NOT upload bank statements that are missing the bank logo, proper bank name, or the account holder's name.",
    ],
  },
  EXEMPTED_STATES_DECLARATION:
    'I, declare to the best of my knowledge and based on the current regulations, I am exempted from filing Income Tax Returns My residence during this period was in.',
  EXEMPTED_STATES: [
    {
      value: 'Sikkim',
      label: 'Sikkim',
    },
    {
      value: 'Leh Ladakh',
      label: 'Leh Ladakh',
    },
    {
      value: 'Nagaland',
      label: 'Nagaland',
    },
    {
      value: 'other',
      label: 'other',
    },
  ],
  VISA_UPLOAD_WARNING: 'Avoid uploading blurry Visa pictures',
  STAMP_VISA_UPLOAD_WARNING:
    'Avoid uploading stamps in the Visa section, as it does not strengthen your application',
  FIRST_TRAVEL_DISABLE_MESSAGE:
    'You cannot change this option once you have added a visa, Please remove the visa to change this option.',
  SELF_SPONSORED_DISABLE_MESSAGE:
    'You cannot change this option once you have added a bank statement or document, Please remove the document or bank statement to change this option.',
  UPLOAD_VISAS: 'Upload visas (jpg/png) ',
  ANOTHER_VISA: 'Another visa (If any)',
  SELF_STATEMENT: 'Upload your bank statement in PDF format',
  SELF_STATEMENT_ALSO_REQUIRED_WITH_GST:
    'According to MOFA guidelines, it is mandatory to upload a Personal Bank Account Statement along with the Company Bank Statement if a GST certificate is being submitted.',
  SPONSOR_STATEMENT: 'Upload sponsor’s bank statement in PDF format',
  SPONSOR_STATEMENT_ALSO_REQUIRED_WITH_GST:
    'Sponsor bank statement is required along with the GST certificate',
  RESET_ITR_PASS: 'https://eportal.incometax.gov.in/iec/foservices/#/login',
  ITR_HINT: 'Linking ITR will strengthen the application.',
  AADHAR_HINT:
    'Linking Aadhar is optional, but it strengthens the application.',
  PASSPORT_HINT:
    'If don’t match, no worries, delete and upload the correct one',
  VISA_NAME_NOT_MATCH:
    'Note: The name on your uploaded visa does not match the name provided in your application. Please consider reviewing and updating if necessary to ensure accuracy in your records',
  INVALID_PASSPORT:
    'Your passport is either invalid or tampered or not a high quality copy. Please upload a high quality colored passport copy.',
  NOT_A_PASSPORT: 'Uploaded document is not a Passport',
  EXPIRED_PASSPORT: 'Your uploaded passport is expired.',
  ERROR_CODE: {
    INVALID_FILE: 'invalid_file',
    DIFFERENT_BANK: 'different_bank',
    PASSWORD_REQUIRED: 'password_required',
    PASSWORD_INVALID: 'password_invalid',
    MODIFIED_FILE: 'modified_file',
    OUT_OF_DATE_RANGE: 'out_of_date_range',
  },
  VISA_ERROR_CODE: {
    VISA_NOT_SCANNED: {
      title: 'Visa not scanned',
      description:
        'The visa document you uploaded could not be scanned. Scanning is essential for processing your application accurately. Please ensure that the document is clear and properly scanned. Consider re-uploading the document if necessary. Your cooperation in resolving this issue is appreciated.',
    },
    NAME_NOT_MATCH: {
      title: 'Name not matched',
      description:
        "The name on the visa you uploaded does not match the name provided in your application. It's crucial for accurate processing that all information aligns. Please review and ensure consistency between the visa and your application details. You may choose to reupload the correct document or proceed by acknowledging this warning.",
    },
    VISA_EXPIRED: {
      title: 'Visa is expired',
      description:
        'The visa you uploaded has expired. Please ensure that the visa is valid and up-to-date. You may choose to re-upload the correct document or proceed by acknowledging this warning.',
    },
    EXP_DATE_NOT_FETCHED: {
      title: 'Expiration date not fetched',
      description:
        "The expiration date couldn't be retrieved from the document you uploaded. This detail is essential for processing your application accurately. Kindly ensure that the document provided is clear and includes the expiration date. You may need to consider re-uploading the document to proceed. Your cooperation in resolving this matter is greatly appreciated.",
    },
    NOT_A_VISA: {
      title: 'Not a visa',
      description:
        'The document you uploaded is not a visa. Please ensure that you are uploading a visa document.',
    },
  },
  ADDITIONAL_SUPPORTING_DOCUMENTS: 'Additional supporting documents (if any)',
  BANK_STATEMENT_PROCESSING:
    'We are now analyzing your bank statement.<br/>This process may take 1-2 minutes, depending on the statement.<br/>Please do not close or refresh this window.',
  INCORRECT_PASSWORD:
    'Password is incorrect \nPlease provide valid password \nPassword is case sensitive!',
  INVALID_OR_SCANNED: 'Uploaded file is either invalid or scanned file',
  DIFFERENT_BANK_FILE:
    'Provided file belongs to different bank.\n Please try again with right bank.',
  MODIFIED_STATEMENT:
    'It seems you have uploaded a modified bank statement file. Please upload bank statement file as you receive from bank',
  OUT_OF_DATE_RANGE_STATEMENT:
    'Please provide a statement dated within the past 12 months',
  BANK_STATEMENT_SCORE_LOW:
    'We suggest including additional bank statements to strengthen your application.',
  AADHAR: 'Aadhar',
  LINK_AADHAR: 'Link your Aadhar',
  PASSPORT_NAME_HINT:
    'Applicant name should be matching to the passport, or should be same as mentioned in the Passport',
  YOUR_AADHAR: (self: boolean) =>
    self ? 'Your Aadhar number' : "Sponsor's Aadhar number",
  IS_SELF_SPONSORED: 'Is your trip self sponsored?',
  WANT_TO_UPLOAD_GST_CERTIFICATE: 'I want to upload GST certificate',
  FIRST_TIME_TRAVEL: 'Are you travelling outside India for the first time?',
  UK_US_VISA: 'Previous visa of USA, Canada, UK, or Schengen',
  OTHER_VISA: 'Previous visa of other countries',
  DONT_ALTER: 'Don’t alter or tamper PDF',
  UPLOAD_SPONSOR_STATEMENT: 'I want to upload sponsor’s bank statements',
  SPONSOR_RELATION_PROOF: 'Relation proof with sponsor',
  ADDITIONAL_COMMENT_PLACEHOLDER:
    'eg: I have uploaded this documents to further support authentication of my application',
  MAKE_STRONG_APPLICATION:
    'Great! your application looks strong.\nAdding more information can make it stronger.',
  PAN_MISMATCH:
    "PAN doesn't match with the one you have provided in the Embassy",
  BANK_SERVICE_PARTIALLY_DOWN_HINT:
  'The bank statement upload service is currently experiencing issues. Some features may be unavailable. Please try again shortly or get in touch with support for help.',
  BANK_SERVICE_COMPLETELY_DOWN_HINT:
    'The bank statement upload service is currently unavailable. Please try again later or get in touch with support for help.',
  ITR_SERVICE_PARTIALLY_DOWN_HINT:
    'The ITR link service is currently experiencing issues. Some features may be unavailable. Please try again shortly or get in touch with support for help.',
  ITR_SERVICE_COMPLETELY_DOWN_HINT:
    'The ITR link service is currently unavailable. Please try again later or get in touch with support for help.',
  AADHAR_SERVICE_PARTIALLY_DOWN_HINT:
    'The Aadhar link service is currently experiencing issues. Some features may be unavailable. Please try again shortly or get in touch with support for help.',
  AADHAR_SERVICE_COMPLETELY_DOWN_HINT:
    'The Aadhar link service is currently unavailable. Please try again later or get in touch with support for help.',
  ITR_NOTE:
    'Please link the same ITR submitted to the embassy along with the physical documents.',
  STATEMENT_UPLOAD_LIMIT: (left: number) =>
    'You can upload a maximum of 20 bank statements. You have ' + (20 - left) +' statements left to upload.',
  STATEMENT_UPLOAD_LIMIT_EXCEEDED:
    'You have exceeded the upload limit of 20 bank statements.',
  FAQS: [
    {
      question:
        'How long will it take to verify the documents uploaded on Duverify website ?',
      answer: '24 Hours',
    },
    {
      question:
        'I  have already paid the visa fees on the embassy website. Why do I need to pay additional fees for DUverify ?',
      answer:
        'This fee is for the documents and background verification services being provided, which is separate from Embassy Visa fee.',
    },
    {
      question:
        'Will my Duverify fees be refunded in case my visa gets rejected ?',
      answer:
        'No. The fee is for the documents and background verification. Grating the visa is at the complete discretion of Embassy of Georgia. DUverify does not guarantee the Visa.',
    },
    {
      question:
        "Will my DUverify fees be refunded in case I don't have all the documents which are required to be uploaded ?",
      answer:
        'No. Fee will not be refunded under any circumstances. After making the Duverify fee you will have 24 hours to upload all the documents.',
    },
    {
      question:
        'How do I ensure that the documents I upload on your website are secured ?',
      answer:
        'We maintain very strict data privacy policies. We are also GDPR compliant which is the highest certification for data protection as per the European Union data laws.',
    },
    {
      question:
        'What if the website crashes during the process and I am unable to complete the process ?',
      answer:
        'You can start the process from the same link you had received on your mail. The process will start from the step you left.',
    },
    {
      question: 'What is the specification of uploading the photo ?',
      answer:
        'The same which is mentioned on the Georgian e visa site. The photo on will be fetched from there.',
    },
    {
      question:
        'What is the maximum file size I can upload for different documents ?',
      answer:
        'No maximum size, however please make sure all the documents are in good pixels and visible for review.',
    },
    {
      question:
        'Will I get an intimation on my mail address or phone after my process is completed ?',
      answer: 'Yes, you will get the mail for the same.',
    },
    {
      question:
        'Will I get an intimation on my mail address or phone if my process is incomplete ?',
      answer: 'No, you will not get the mail for the same.',
    },
    {
      question:
        'How do I track the status of my verification and visa application ?',
      answer:
        "You can't track the status of your verification, you will have to follow up with the Georgian embassy in case you don't get any intimation from them about your visa after 24 hours of you completing the entire process, including verification.",
    },
    {
      question:
        'Do I need to attend the embassy in person for document verification ?',
      answer:
        'In some cases, you may be asked to attend the embassy in person for document verification.',
    },
    {
      question: 'What is the purpose of document verification ?',
      answer:
        'It is for the embassy to take a decision to authenticate your details and take a decision to grant/reject your visa.',
    },
    {
      question: 'What documents do I need to submit for verification ?',
      answer:
        'Passport front and back clear copies in PDF/JPEG, 6 months bank statement (Bank PDF only, Scanned copied not accepted), Aadhar details registered to the mobile number for OTP validation.',
    },
    {
      question: 'Is there a fee for document verification ?',
      answer: '15 USD.',
    },
    {
      question:
        'How do I know if my documents have been successfully verified ?',
      answer:
        'There is no means to track the status. You will get to know about your visa status from the consulate in the stipulated time.',
    },
    {
      question: 'What are the consequences of submitting false information ?',
      answer: 'Your visa will be rejected.',
    },
    {
      question:
        'What should I do if I am unable to submit the required documents ?',
      answer:
        'The fees that you pay as Visa fees and DuVerify fees for Verification is non-refundable. You visa will not be processed without the required documents.',
    },
    {
      question:
        'Is there any way to expedite the document verification process ?',
      answer: 'No.',
    },
  ],
};
